<script>
    let className = '';
    export { className as class };
    import branch from '$lib/assets/branch.svg?raw';

</script>

<div class="award flex flex-nowrap gap-4 max-w-xs justify-center {className}">
    <span>{@html branch}</span>
    <div class="flex flex-col text-center">
        <div class="text-xl font-bold">Best Life Skills<br> Education Website</div>
        <div>by Homeschool.com</div>
    </div>
    <span class="scale-x-[-1]">{@html branch}</span>
</div>
